import React from 'react';
import {
  SearchByPropertyResult,
  SearchByPropertyResultItem,
} from 'pages/Search/models';
import { Typography, Row, Col, Divider, Tabs, Icon } from 'antd';
import SearchExport from 'pages/Search/SearchExport/SearchExport';
import { AttributeValuePair } from 'common';
import SearchByPropertyResultTabs from './SearchByPropertyResultTabs';

const { Title } = Typography;
const { TabPane } = Tabs;

const ResultReports: React.FC<{
  result: SearchByPropertyResult | null;
}> = (props: { result: SearchByPropertyResult | null }) => {
  const { result } = props;

  return (
    <>
      <Row type="flex" justify="space-between" align="middle">
        {result && (
          <Col>
            <Title level={4}>Search Criteria: {result.searchCriteria}</Title>
            {result.results.length === 1 &&
              result.results[0].listOfProperties?.length === 1 && (
                <>
                  {result.results[0].listOfProperties[0].county && (
                    <AttributeValuePair
                      attribute={`County`}
                      value={result.results[0].listOfProperties[0].county}
                    />
                  )}
                  &nbsp;
                  <AttributeValuePair
                    attribute={`Block/Lot`}
                    value={`${parseInt(
                      result.results[0].listOfProperties[0].block,
                    )}/${parseInt(result.results[0].listOfProperties[0].lot)}`}
                  />
                  &nbsp;
                  {result.results[0].listOfProperties[0].ease && (
                    <>
                      <AttributeValuePair
                        attribute={`Easement`}
                        value={result.results[0].listOfProperties[0].ease}
                      />
                      &nbsp;
                    </>
                  )}
                  &nbsp;
                  {result.results[0].listOfProperties[0].address && (
                    <AttributeValuePair
                      attribute={`Address`}
                      value={result.results[0].listOfProperties[0].address}
                    />
                  )}
                </>
              )}
          </Col>
        )}

        <SearchExport />
        <Divider dashed />
      </Row>

      <Tabs type="card">
        {result?.results?.length &&
          result?.results?.map(
            (resultItem: SearchByPropertyResultItem, index: number) => (
              <TabPane
                tab={
                  <>
                    <Icon type="file" />
                    &nbsp;
                    {resultItem.tabTitle}
                  </>
                }
                key={`${index}`}
              >
                <SearchByPropertyResultTabs
                  result={resultItem}
                  searchId={result.searchId}
                />
              </TabPane>
            ),
          )}
      </Tabs>
    </>
  );
};

export default React.memo(ResultReports);
